import FooterUtente, { infoUtente, loadFooter } from "../../visualComponents/FooterUtente";
import React, { useState, useEffect } from 'react';
import { ArrowDownAZ, ArrowUpAZ } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import Loader from "../../visualComponents/Loader.js";
import NavBar from "../../visualComponents/NavBarGenerale.js";

let isLoading = false;

const TableRow = ({ data }) => {
    const navigate = useNavigate();

    const handleSelect = () => {
        document.cookie = `IDAzienda=${data.ID}; path=/`;
        navigate('/dashUtente/componenti');
    };

    return (
        <div className="mt-2">
            <div
                className="col-span-2 bg-gray-300 dark:bg-gray-500 divide-x divide-black dark:divide-white rounded-lg grid grid-cols-2 p-4 text-center break-words items-center"
                onClick={handleSelect}
            >
                <div>{data.Nome}</div>
                <div>{data.Indirizzo}</div>
            </div>
        </div>
    );
};

const DashUtente = () => {
    const [indexTabella, setIndexTabella] = useState([
        { value: "Nome", dbCode: "Nome", ascending: true, filter: "text" },
        { value: "Indirizzo", dbCode: "Indirizzo", ascending: true, filter: "text" }
    ]);
    const [filters, setFilters] = useState({
        Nome: "",
        Indirizzo: ""
    });
    const [data, setData] = useState([]);
    const [viewData, setViewData] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        onload();
    }, []);

    useEffect(() => {
        setViewData(data);
    }, [data]);

    useEffect(() => {
        let newData = [...data];
        for (const key in filters) {
            if (filters[key] !== "") {
                newData = newData.filter((d) => (d.value[key].toString().toLowerCase().includes(filters[key].toLowerCase())));
            }
        };
        setViewData(newData);
    }, [filters]);

    const onload = async () => {
        try {
            isLoading = true;

            await loadFooter();

            const response = await fetch("/getAziendeByUtente", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ 
                    CodiceDominio: infoUtente.CodiceDominio,
                    IDUtente: infoUtente.ID
                })
            });

            const responseData = await response.json();

            if(response.status === 500){
                alert(responseData.error);
                console.log(responseData.error);
                navigate('/');
            }
            else {
                isLoading = false;
                setData(responseData.map((d) => ({ value: d })));
            }
        } catch (error) {
            alert("Errore nell'operazione");
            console.log(error);
            navigate('/');
        }
    };

    const sortByColumn = (column) => {
        setIndexTabella((prevIndexTabella) =>
            prevIndexTabella.map((d) =>
                d.dbCode === column ? { ...d, ascending: !d.ascending } : d
            )
        );

        const isAscending = indexTabella.find((d) => d.dbCode === column)?.ascending;
        let newData = [...viewData];

        newData.sort((a, b) => {
            if (a.value[column] > b.value[column]) return isAscending ? -1 : 1;
            if (a.value[column] < b.value[column]) return isAscending ? 1 : -1;
            return 0;
        });

        setViewData(newData);
    };

    return (
        <div className="min-h-screen bg-white dark:bg-gray-800">
            <NavBar page="BENTORNATO" />
            {isLoading && <Loader />}
            <div className="bg-white dark:bg-gray-800 text-black dark:text-white mb-20 pt-[4rem]">
                <div id="tabella" className="">
                    <div className="col-span-2 bg-gray-400 dark:bg-gray-600 divide-x divide-black dark:divide-white rounded-lg grid grid-cols-2 p-4 font-bold text-center">
                        {
                            indexTabella.map((d, index) => (
                                <div key={index} onClick={() => sortByColumn(d.dbCode)} className="hover:cursor-pointer grid grid-cols-1 flex items-center justify-center">
                                    <p className="flex items-center justify-self-center">{d.value}</p>
                                    <button className="ml-2 text-gray-500 dark:text-gray-700 justify-self-center">
                                        {d.ascending ? <ArrowDownAZ size={24} /> : <ArrowUpAZ size={24} />}
                                    </button>
                                </div>
                            ))
                        }
                    </div>
                    <div className="grid grid-cols-2 grid-row-1 gap-1 mt-2">
                        <div></div>
                        <div className="col-span-2 rounded-lg grid grid-cols-2 py-4 font-bold text-center divide-x divide-black dark:divide-white">
                            {
                                indexTabella.map((d, index) => (
                                    <div key={index} className={`flex items-center justify-center ${index === 0 ? "mr-2" : index === 1 ? "pl-2" : "px-2"}`}>
                                        <input
                                            type={d.filter}
                                            placeholder={d.value}
                                            value={filters[d.dbCode]}
                                            className="rounded bg-gray-100 dark:bg-gray-300 border-2 border-gray-200 dark:border-gray-400 p-1 md:px-1 text-center w-full"
                                            onChange={(e) => setFilters({ ...filters, [d.dbCode]: e.target.value })}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                        <div></div>
                    </div>
                    {viewData.map((d, index) => (
                        <TableRow key={index} data={d.value} />
                    ))}
                </div>
            </div>
            <FooterUtente />
        </div>
    );
};

export default DashUtente;